module.exports = __webpack_public_path__ + "static/media/g.9635687e.jpg";